import React from 'react';
import { Box, Typography } from '@mui/material';
import {Link} from "react-router-dom";

export default function PageNotFound(){
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                minHeight: '100vh',
                backgroundColor:'#17225A'
            }}
        >
            <Typography variant="h1" style={{ color: 'white' }}>
                404
            </Typography>
            <Typography variant="h6" style={{ color: 'white' }}>
                The page you’re looking for doesn’t exist.
            </Typography>
            <Link to="/" className='btn btn-primary'>Back Home</Link>
        </Box>
    )
}